(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name LocsController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('LocsController', LocsController);
    LocsController.$inject = ["LocsService","$scope","$timeout"];

    function LocsController(LocsService,$scope,$timeout){
         
        var vm = this;
        vm.ids = {};
        vm.locs =  [];
        vm.loc =  null;
        vm.typeloc =  null;

        $scope.$on("markerClick",function(e,layer)
        {
            //console.log("hey")
            e.stopPropagation();
            angular.forEach(vm.locs,function(value,key){

                if(value.url_map == layer.getId()){
                  $timeout(function()
                  {
                    vm.loc = vm.locs[key];  
                  })
                    
                }
            });
                    
        });
      
      vm.getLocs = function(){

            //console.log(vm.ids);
            LocsService.getLocs(vm).then(function(data){ 

                vm.locs = data.locs;
            });
             
        }
    }    

    })();